import * as types from '../../lib/actionTypes.es6';
import { take, call, put } from 'redux-saga/effects';
import {
  getWebhookSubscriptions,
  createWebhookSubscription,
  updateWebhookSubscription,
  deleteWebhookSubscription,
  saveWebhookSubscriptionAuth,
  deleteWebhookSubscriptionAuth,
} from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

export function* getAllWebhookSubscriptionsRequestWatcher() {
  while (true) {
    const requestAction = yield take(types.VIEW_ALL_WEBHOOK_SUBSCRIPTIONS_REQUEST);
    let response = {};
    try {
      response = yield call(getWebhookSubscriptions, requestAction.payload);
      // Backend returns a paginated envelope { data: [], page, size, total }
      const subscriptions = response.data && response.data.data ? response.data.data : [];
      yield put(actions.getAllWebhookSubscriptionsSuccess(subscriptions));
    } catch (e) {
      let errorPayload = {};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      GAloggerException(e);
      yield put(actions.getAllWebhookSubscriptionsFail(errorPayload));
    }
  }
}

export function* createWebhookSubscriptionRequestWatcher() {
  while (true) {
    const requestAction = yield take(types.CREATE_WEBHOOK_SUBSCRIPTION_REQUEST);
    let response = {};
    try {
      response = yield call(createWebhookSubscription, requestAction.payload);
      yield put(actions.createWebhookSubscriptionSuccess(response.data));
      yield put(actions.getAllWebhookSubscriptionsRequest());
    } catch (e) {
      let errorPayload = {};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      GAloggerException(e);
      yield put(actions.createWebhookSubscriptionFail(errorPayload));
    }
  }
}

export function* editWebhookSubscriptionRequestWatcher() {
  while (true) {
    const requestAction = yield take(types.EDIT_WEBHOOK_SUBSCRIPTION_REQUEST);
    let response = {};
    try {
      // Destructure guid out so it's only used as a URL param, not sent in the body
      const { guid, ...body } = requestAction.payload;
      response = yield call(
        updateWebhookSubscription,
        guid,
        body
      );
      yield put(actions.editWebhookSubscriptionSuccess(response.data));
      yield put(actions.getAllWebhookSubscriptionsRequest());
    } catch (e) {
      let errorPayload = {};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      GAloggerException(e);
      yield put(actions.editWebhookSubscriptionFail(errorPayload));
    }
  }
}

export function* deleteWebhookSubscriptionRequestWatcher() {
  while (true) {
    const requestAction = yield take(types.DELETE_WEBHOOK_SUBSCRIPTION_REQUEST);
    let response = {};
    try {
      response = yield call(deleteWebhookSubscription, requestAction.payload);
      yield put(actions.deleteWebhookSubscriptionSuccess(response.data));
      yield put(actions.getAllWebhookSubscriptionsRequest());
    } catch (e) {
      let errorPayload = {};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      GAloggerException(e);
      yield put(actions.deleteWebhookSubscriptionFail(errorPayload));
    }
  }
}

export function* saveWebhookSubscriptionAuthRequestWatcher() {
  while (true) {
    const requestAction = yield take(types.SAVE_WEBHOOK_SUBSCRIPTION_AUTH_REQUEST);
    let response = {};
    try {
      response = yield call(
        saveWebhookSubscriptionAuth,
        requestAction.payload.guid,
        requestAction.payload.authConfig
      );
      yield put(actions.saveWebhookSubscriptionAuthSuccess(response.data));
      yield put(actions.getAllWebhookSubscriptionsRequest());
    } catch (e) {
      let errorPayload = {};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      GAloggerException(e);
      yield put(actions.saveWebhookSubscriptionAuthFail(errorPayload));
    }
  }
}

export function* deleteWebhookSubscriptionAuthRequestWatcher() {
  while (true) {
    const requestAction = yield take(types.DELETE_WEBHOOK_SUBSCRIPTION_AUTH_REQUEST);
    let response = {};
    try {
      response = yield call(deleteWebhookSubscriptionAuth, requestAction.payload);
      yield put(actions.deleteWebhookSubscriptionAuthSuccess(response.data));
      yield put(actions.getAllWebhookSubscriptionsRequest());
    } catch (e) {
      let errorPayload = {};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      GAloggerException(e);
      yield put(actions.deleteWebhookSubscriptionAuthFail(errorPayload));
    }
  }
}
